export default {
  Model: {
    TYPING_PARTICIPANTS: 'typingParticipants',
    SEEN_WORKSPACE_ITEM_IDS: 'seenWorkspaceItemIds',
    SEEN_WORKSPACE_ITEM_IDS_IN_NAVIGATIONAL_ORDER: 'seenWorkspaceItemIdsInNavigationalOrder',
    NUMSTEPS: 'numSteps',
    STEP_INDEX: 'stepIndex',
    STATE: 'state',
    PARTICIPANT_IDS: 'participantIds',
    WORKSPACE_ITEM_ID: 'workspaceItemId',
    WORKSPACE_ITEM_UUID: 'workspaceItemUuid',
    WORKSPACE_SLUG: 'workspaceSlug',
    ID: 'id',
    ACTIVE: 'active',
    IS_LAST_AGENDA_ITEM: 'isLastAgendaItem',
    CREATED_AT: 'createdAt',
  },
  Params: {
    UPDATE: 'update',
    ITEM_UUID: 'item_uuid',
    STATE: 'state',
  },
  Actions: {
    FETCH_MEET_MODE_SUCCESS: 'workspace_meet_mode/FETCH_MEET_MODE_SUCCESS',
    START_MEET_MODE_SUCCESS: 'workspace_meet_mode/START_MEET_MODE_SUCCESS',
    LEAVE_MEET_MODE_SUCCESS: 'workspace_meet_mode/LEAVE_MEET_MODE_SUCCESS',
    UPDATE_MEET_MODE_SUCCESS: 'workspace_meet_mode/UPDATE_MEET_MODE_SUCCESS',
    ACTION_CABLE_UPDATE_SUCCESS: 'workspace_meet_mode/ACTION_CABLE_UPDATE_SUCCESS',
    DISMISS_PARTICIPANT_POPOVER_SUCCESS: 'workspace_meet_mode/DISMISS_PARTICIPANT_POPOVER_SUCCESS',
    INVITE_BOT_SUCCESS: 'workspace_meet_mode/INVITE_BOT_SUCCESS',
    REMOVE_BOT_SUCCESS: 'workspace_meet_mode/REMOVE_BOT_SUCCESS',
    FETCH_BOT_SUCCESS: 'workspace_meet_mode/FETCH_BOT_SUCCESS',
  },
  State: {
    WORKSPACE_MEETING_MODES_BY_WORKSPACE_ID: 'WORKSPACE_MEETING_MODES_BY_WORKSPACE_ID',
    DISMISSED_PARTICIPANT_POPOVER_MEET_MODE_ID: 'DISMISSED_PARTICIPANT_POPOVER_MEET_MODE_ID',
    WORKSPACE_BOTS: 'WORKSPACE_BOTS',
  },
};
